

function userManagementAdmin() {

    let userService = [
        {
            name: "User Mangement Admin",
            icon: "user-management",
            logoName: "user",
            // flag: "voucherRequired",
            displayService: "userManagementAdmin",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/user-managementAdmin",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD",
            },
        ];

        return dashboardArr;
    };

    const userMaster = () => {
        const profileArr = [
            {
                path: "/index/BackOfficeAdmin",
                name: "Back Office",
                icon: "user-master",
                logoName: "userManagement",
                flag: "BACK OFFICE",
            },
        ];

        // if (
        //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
        // ) {
        return profileArr;
        // } else {
        //   return "";
        // }
    };
    const userModuleAllocation = () => {
        const profileArr = [
            {
                path: "/index/moduleAllocationAdmin",
                name: "Add Module",
                icon: "create-wallet",
                logoName: "CREATE OWNER",
            flag: "ADD MODULE"
                
            },
        ];

        // if (
        //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
        // ) {
        return profileArr;
        // } else {
        //   return "";
        // }
    };

    let a = dashboard();
    let b = userMaster();
    let c = userModuleAllocation();

    userService[0].items = [...a, ...b,...c];

    return userService;
}

export default userManagementAdmin;
